import Ae from "react";
import { Button as cr, Text as sr, Badge as ur, Modal as D, TextInput as fr, Tabs as V, MantineProvider as dr } from "@mantine/core";
var ae = { exports: {} }, N = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ee, ke;
function $e() {
  if (ke) return ee;
  ke = 1;
  var n = Object.getOwnPropertySymbols, p = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
  function E(d) {
    if (d == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(d);
  }
  function C() {
    try {
      if (!Object.assign)
        return !1;
      var d = new String("abc");
      if (d[5] = "de", Object.getOwnPropertyNames(d)[0] === "5")
        return !1;
      for (var R = {}, v = 0; v < 10; v++)
        R["_" + String.fromCharCode(v)] = v;
      var m = Object.getOwnPropertyNames(R).map(function(f) {
        return R[f];
      });
      if (m.join("") !== "0123456789")
        return !1;
      var y = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        y[f] = f;
      }), Object.keys(Object.assign({}, y)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ee = C() ? Object.assign : function(d, R) {
    for (var v, m = E(d), y, f = 1; f < arguments.length; f++) {
      v = Object(arguments[f]);
      for (var O in v)
        p.call(v, O) && (m[O] = v[O]);
      if (n) {
        y = n(v);
        for (var b = 0; b < y.length; b++)
          c.call(v, y[b]) && (m[y[b]] = v[y[b]]);
      }
    }
    return m;
  }, ee;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Se;
function vr() {
  if (Se) return N;
  Se = 1, $e();
  var n = Ae, p = 60103;
  if (N.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var c = Symbol.for;
    p = c("react.element"), N.Fragment = c("react.fragment");
  }
  var E = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, C = Object.prototype.hasOwnProperty, d = { key: !0, ref: !0, __self: !0, __source: !0 };
  function R(v, m, y) {
    var f, O = {}, b = null, S = null;
    y !== void 0 && (b = "" + y), m.key !== void 0 && (b = "" + m.key), m.ref !== void 0 && (S = m.ref);
    for (f in m) C.call(m, f) && !d.hasOwnProperty(f) && (O[f] = m[f]);
    if (v && v.defaultProps) for (f in m = v.defaultProps, m) O[f] === void 0 && (O[f] = m[f]);
    return { $$typeof: p, type: v, key: b, ref: S, props: O, _owner: E.current };
  }
  return N.jsx = R, N.jsxs = R, N;
}
var re = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var De;
function gr() {
  return De || (De = 1, function(n) {
    process.env.NODE_ENV !== "production" && function() {
      var p = Ae, c = $e(), E = 60103, C = 60106;
      n.Fragment = 60107;
      var d = 60108, R = 60114, v = 60109, m = 60110, y = 60112, f = 60113, O = 60120, b = 60115, S = 60116, W = 60121, te = 60122, ne = 60117, oe = 60129, ie = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var h = Symbol.for;
        E = h("react.element"), C = h("react.portal"), n.Fragment = h("react.fragment"), d = h("react.strict_mode"), R = h("react.profiler"), v = h("react.provider"), m = h("react.context"), y = h("react.forward_ref"), f = h("react.suspense"), O = h("react.suspense_list"), b = h("react.memo"), S = h("react.lazy"), W = h("react.block"), te = h("react.server.block"), ne = h("react.fundamental"), h("react.scope"), h("react.opaque.id"), oe = h("react.debug_trace_mode"), h("react.offscreen"), ie = h("react.legacy_hidden");
      }
      var le = typeof Symbol == "function" && Symbol.iterator, Ie = "@@iterator";
      function Ne(e) {
        if (e === null || typeof e != "object")
          return null;
        var r = le && e[le] || e[Ie];
        return typeof r == "function" ? r : null;
      }
      var A = p.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function j(e) {
        {
          for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), t = 1; t < r; t++)
            a[t - 1] = arguments[t];
          Fe("error", e, a);
        }
      }
      function Fe(e, r, a) {
        {
          var t = A.ReactDebugCurrentFrame, u = t.getStackAddendum();
          u !== "" && (r += "%s", a = a.concat([u]));
          var s = a.map(function(i) {
            return "" + i;
          });
          s.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, s);
        }
      }
      var Ye = !1;
      function Me(e) {
        return !!(typeof e == "string" || typeof e == "function" || e === n.Fragment || e === R || e === oe || e === d || e === f || e === O || e === ie || Ye || typeof e == "object" && e !== null && (e.$$typeof === S || e.$$typeof === b || e.$$typeof === v || e.$$typeof === m || e.$$typeof === y || e.$$typeof === ne || e.$$typeof === W || e[0] === te));
      }
      function We(e, r, a) {
        var t = r.displayName || r.name || "";
        return e.displayName || (t !== "" ? a + "(" + t + ")" : a);
      }
      function ce(e) {
        return e.displayName || "Context";
      }
      function P(e) {
        if (e == null)
          return null;
        if (typeof e.tag == "number" && j("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof e == "function")
          return e.displayName || e.name || null;
        if (typeof e == "string")
          return e;
        switch (e) {
          case n.Fragment:
            return "Fragment";
          case C:
            return "Portal";
          case R:
            return "Profiler";
          case d:
            return "StrictMode";
          case f:
            return "Suspense";
          case O:
            return "SuspenseList";
        }
        if (typeof e == "object")
          switch (e.$$typeof) {
            case m:
              var r = e;
              return ce(r) + ".Consumer";
            case v:
              var a = e;
              return ce(a._context) + ".Provider";
            case y:
              return We(e, e.render, "ForwardRef");
            case b:
              return P(e.type);
            case W:
              return P(e._render);
            case S: {
              var t = e, u = t._payload, s = t._init;
              try {
                return P(s(u));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var F = 0, se, ue, fe, de, ve, ge, pe;
      function me() {
      }
      me.__reactDisabledLog = !0;
      function Be() {
        {
          if (F === 0) {
            se = console.log, ue = console.info, fe = console.warn, de = console.error, ve = console.group, ge = console.groupCollapsed, pe = console.groupEnd;
            var e = {
              configurable: !0,
              enumerable: !0,
              value: me,
              writable: !0
            };
            Object.defineProperties(console, {
              info: e,
              log: e,
              warn: e,
              error: e,
              group: e,
              groupCollapsed: e,
              groupEnd: e
            });
          }
          F++;
        }
      }
      function qe() {
        {
          if (F--, F === 0) {
            var e = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: c({}, e, {
                value: se
              }),
              info: c({}, e, {
                value: ue
              }),
              warn: c({}, e, {
                value: fe
              }),
              error: c({}, e, {
                value: de
              }),
              group: c({}, e, {
                value: ve
              }),
              groupCollapsed: c({}, e, {
                value: ge
              }),
              groupEnd: c({}, e, {
                value: pe
              })
            });
          }
          F < 0 && j("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var G = A.ReactCurrentDispatcher, z;
      function B(e, r, a) {
        {
          if (z === void 0)
            try {
              throw Error();
            } catch (u) {
              var t = u.stack.trim().match(/\n( *(at )?)/);
              z = t && t[1] || "";
            }
          return `
` + z + e;
        }
      }
      var J = !1, q;
      {
        var Le = typeof WeakMap == "function" ? WeakMap : Map;
        q = new Le();
      }
      function he(e, r) {
        if (!e || J)
          return "";
        {
          var a = q.get(e);
          if (a !== void 0)
            return a;
        }
        var t;
        J = !0;
        var u = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var s;
        s = G.current, G.current = null, Be();
        try {
          if (r) {
            var i = function() {
              throw Error();
            };
            if (Object.defineProperty(i.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(i, []);
              } catch (k) {
                t = k;
              }
              Reflect.construct(e, [], i);
            } else {
              try {
                i.call();
              } catch (k) {
                t = k;
              }
              e.call(i.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (k) {
              t = k;
            }
            e();
          }
        } catch (k) {
          if (k && t && typeof k.stack == "string") {
            for (var o = k.stack.split(`
`), x = t.stack.split(`
`), g = o.length - 1, _ = x.length - 1; g >= 1 && _ >= 0 && o[g] !== x[_]; )
              _--;
            for (; g >= 1 && _ >= 0; g--, _--)
              if (o[g] !== x[_]) {
                if (g !== 1 || _ !== 1)
                  do
                    if (g--, _--, _ < 0 || o[g] !== x[_]) {
                      var w = `
` + o[g].replace(" at new ", " at ");
                      return typeof e == "function" && q.set(e, w), w;
                    }
                  while (g >= 1 && _ >= 0);
                break;
              }
          }
        } finally {
          J = !1, G.current = s, qe(), Error.prepareStackTrace = u;
        }
        var I = e ? e.displayName || e.name : "", we = I ? B(I) : "";
        return typeof e == "function" && q.set(e, we), we;
      }
      function _e(e, r, a) {
        return he(e, !1);
      }
      function Ue(e) {
        var r = e.prototype;
        return !!(r && r.isReactComponent);
      }
      function L(e, r, a) {
        if (e == null)
          return "";
        if (typeof e == "function")
          return he(e, Ue(e));
        if (typeof e == "string")
          return B(e);
        switch (e) {
          case f:
            return B("Suspense");
          case O:
            return B("SuspenseList");
        }
        if (typeof e == "object")
          switch (e.$$typeof) {
            case y:
              return _e(e.render);
            case b:
              return L(e.type, r, a);
            case W:
              return _e(e._render);
            case S: {
              var t = e, u = t._payload, s = t._init;
              try {
                return L(s(u), r, a);
              } catch {
              }
            }
          }
        return "";
      }
      var ye = {}, be = A.ReactDebugCurrentFrame;
      function U(e) {
        if (e) {
          var r = e._owner, a = L(e.type, e._source, r ? r.type : null);
          be.setExtraStackFrame(a);
        } else
          be.setExtraStackFrame(null);
      }
      function Ve(e, r, a, t, u) {
        {
          var s = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var i in e)
            if (s(e, i)) {
              var o = void 0;
              try {
                if (typeof e[i] != "function") {
                  var x = Error((t || "React class") + ": " + a + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[i] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw x.name = "Invariant Violation", x;
                }
                o = e[i](r, i, t, a, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (g) {
                o = g;
              }
              o && !(o instanceof Error) && (U(u), j("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", t || "React class", a, i, typeof o), U(null)), o instanceof Error && !(o.message in ye) && (ye[o.message] = !0, U(u), j("Failed %s type: %s", a, o.message), U(null));
            }
        }
      }
      var Y = A.ReactCurrentOwner, K = Object.prototype.hasOwnProperty, Ge = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, xe, Ee, H;
      H = {};
      function ze(e) {
        if (K.call(e, "ref")) {
          var r = Object.getOwnPropertyDescriptor(e, "ref").get;
          if (r && r.isReactWarning)
            return !1;
        }
        return e.ref !== void 0;
      }
      function Je(e) {
        if (K.call(e, "key")) {
          var r = Object.getOwnPropertyDescriptor(e, "key").get;
          if (r && r.isReactWarning)
            return !1;
        }
        return e.key !== void 0;
      }
      function Ke(e, r) {
        if (typeof e.ref == "string" && Y.current && r && Y.current.stateNode !== r) {
          var a = P(Y.current.type);
          H[a] || (j('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', P(Y.current.type), e.ref), H[a] = !0);
        }
      }
      function He(e, r) {
        {
          var a = function() {
            xe || (xe = !0, j("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
          };
          a.isReactWarning = !0, Object.defineProperty(e, "key", {
            get: a,
            configurable: !0
          });
        }
      }
      function Xe(e, r) {
        {
          var a = function() {
            Ee || (Ee = !0, j("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
          };
          a.isReactWarning = !0, Object.defineProperty(e, "ref", {
            get: a,
            configurable: !0
          });
        }
      }
      var Ze = function(e, r, a, t, u, s, i) {
        var o = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: E,
          // Built-in properties that belong on the element
          type: e,
          key: r,
          ref: a,
          props: i,
          // Record the component responsible for creating this element.
          _owner: s
        };
        return o._store = {}, Object.defineProperty(o._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(o, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: t
        }), Object.defineProperty(o, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: u
        }), Object.freeze && (Object.freeze(o.props), Object.freeze(o)), o;
      };
      function Qe(e, r, a, t, u) {
        {
          var s, i = {}, o = null, x = null;
          a !== void 0 && (o = "" + a), Je(r) && (o = "" + r.key), ze(r) && (x = r.ref, Ke(r, u));
          for (s in r)
            K.call(r, s) && !Ge.hasOwnProperty(s) && (i[s] = r[s]);
          if (e && e.defaultProps) {
            var g = e.defaultProps;
            for (s in g)
              i[s] === void 0 && (i[s] = g[s]);
          }
          if (o || x) {
            var _ = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
            o && He(i, _), x && Xe(i, _);
          }
          return Ze(e, o, x, u, t, Y.current, i);
        }
      }
      var X = A.ReactCurrentOwner, Re = A.ReactDebugCurrentFrame;
      function $(e) {
        if (e) {
          var r = e._owner, a = L(e.type, e._source, r ? r.type : null);
          Re.setExtraStackFrame(a);
        } else
          Re.setExtraStackFrame(null);
      }
      var Z;
      Z = !1;
      function Q(e) {
        return typeof e == "object" && e !== null && e.$$typeof === E;
      }
      function je() {
        {
          if (X.current) {
            var e = P(X.current.type);
            if (e)
              return `

Check the render method of \`` + e + "`.";
          }
          return "";
        }
      }
      function er(e) {
        return "";
      }
      var Oe = {};
      function rr(e) {
        {
          var r = je();
          if (!r) {
            var a = typeof e == "string" ? e : e.displayName || e.name;
            a && (r = `

Check the top-level render call using <` + a + ">.");
          }
          return r;
        }
      }
      function Te(e, r) {
        {
          if (!e._store || e._store.validated || e.key != null)
            return;
          e._store.validated = !0;
          var a = rr(r);
          if (Oe[a])
            return;
          Oe[a] = !0;
          var t = "";
          e && e._owner && e._owner !== X.current && (t = " It was passed a child from " + P(e._owner.type) + "."), $(e), j('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', a, t), $(null);
        }
      }
      function Ce(e, r) {
        {
          if (typeof e != "object")
            return;
          if (Array.isArray(e))
            for (var a = 0; a < e.length; a++) {
              var t = e[a];
              Q(t) && Te(t, r);
            }
          else if (Q(e))
            e._store && (e._store.validated = !0);
          else if (e) {
            var u = Ne(e);
            if (typeof u == "function" && u !== e.entries)
              for (var s = u.call(e), i; !(i = s.next()).done; )
                Q(i.value) && Te(i.value, r);
          }
        }
      }
      function ar(e) {
        {
          var r = e.type;
          if (r == null || typeof r == "string")
            return;
          var a;
          if (typeof r == "function")
            a = r.propTypes;
          else if (typeof r == "object" && (r.$$typeof === y || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          r.$$typeof === b))
            a = r.propTypes;
          else
            return;
          if (a) {
            var t = P(r);
            Ve(a, e.props, "prop", t, e);
          } else if (r.PropTypes !== void 0 && !Z) {
            Z = !0;
            var u = P(r);
            j("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", u || "Unknown");
          }
          typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && j("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function tr(e) {
        {
          for (var r = Object.keys(e.props), a = 0; a < r.length; a++) {
            var t = r[a];
            if (t !== "children" && t !== "key") {
              $(e), j("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", t), $(null);
              break;
            }
          }
          e.ref !== null && ($(e), j("Invalid attribute `ref` supplied to `React.Fragment`."), $(null));
        }
      }
      function Pe(e, r, a, t, u, s) {
        {
          var i = Me(e);
          if (!i) {
            var o = "";
            (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (o += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var x = er();
            x ? o += x : o += je();
            var g;
            e === null ? g = "null" : Array.isArray(e) ? g = "array" : e !== void 0 && e.$$typeof === E ? (g = "<" + (P(e.type) || "Unknown") + " />", o = " Did you accidentally export a JSX literal instead of a component?") : g = typeof e, j("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", g, o);
          }
          var _ = Qe(e, r, a, u, s);
          if (_ == null)
            return _;
          if (i) {
            var w = r.children;
            if (w !== void 0)
              if (t)
                if (Array.isArray(w)) {
                  for (var I = 0; I < w.length; I++)
                    Ce(w[I], e);
                  Object.freeze && Object.freeze(w);
                } else
                  j("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ce(w, e);
          }
          return e === n.Fragment ? tr(_) : ar(_), _;
        }
      }
      function nr(e, r, a) {
        return Pe(e, r, a, !0);
      }
      function or(e, r, a) {
        return Pe(e, r, a, !1);
      }
      var ir = or, lr = nr;
      n.jsx = ir, n.jsxs = lr;
    }();
  }(re)), re;
}
process.env.NODE_ENV === "production" ? ae.exports = vr() : ae.exports = gr();
var l = ae.exports;
const pr = ({ name: n, customCss: p = "" }) => /* @__PURE__ */ l.jsx("span", { className: `material-symbols-outlined ${p}`, children: n }), mr = "_root_yu1ox_1", hr = "_title_yu1ox_6", _r = "_description_yu1ox_13", yr = "_action_yu1ox_19", br = "_icon_yu1ox_23", M = {
  root: mr,
  title: hr,
  description: _r,
  action: yr,
  icon: br
}, Ir = ({ title: n, description: p, renderAction: c }) => /* @__PURE__ */ l.jsxs("section", { className: M.root, children: [
  /* @__PURE__ */ l.jsx("div", { className: M.icon, children: /* @__PURE__ */ l.jsx(pr, { name: "book_2" }) }),
  /* @__PURE__ */ l.jsx("h2", { className: M.title, children: n }),
  /* @__PURE__ */ l.jsx("p", { className: M.description, children: p }),
  /* @__PURE__ */ l.jsx("div", { className: M.action, children: c == null ? void 0 : c() })
] }), Nr = (n) => /* @__PURE__ */ l.jsx(
  cr,
  {
    color: "gray",
    variant: n.variant,
    fullWidth: n.fullWidth,
    ...n,
    children: n.children
  }
), xr = "_root_1vq6d_1", Er = "_container_1vq6d_5", Rr = "_containerMobile_1vq6d_12", jr = "_figure_1vq6d_20", Or = "_content_1vq6d_32", Tr = "_children_1vq6d_33", Cr = "_contentMobile_1vq6d_43", Pr = "_title_1vq6d_56", wr = "_titleMobile_1vq6d_62", kr = "_actions_1vq6d_72", Sr = "_badges_1vq6d_78", T = {
  root: xr,
  container: Er,
  containerMobile: Rr,
  figure: jr,
  content: Or,
  children: Tr,
  contentMobile: Cr,
  title: Pr,
  titleMobile: wr,
  actions: kr,
  badges: Sr
}, Fr = ({
  title: n,
  badges: p,
  children: c,
  renderActions: E,
  imageUrl: C,
  isMobile: d
}) => /* @__PURE__ */ l.jsx("article", { className: T.root, children: /* @__PURE__ */ l.jsxs("div", { className: d ? T.containerMobile : T.container, children: [
  /* @__PURE__ */ l.jsx("figure", { className: T.figure, children: /* @__PURE__ */ l.jsx("img", { src: C, alt: `Imagem de capa do livro ${n}` }) }),
  /* @__PURE__ */ l.jsxs("section", { className: d ? T.contentMobile : T.content, children: [
    /* @__PURE__ */ l.jsx(
      "h2",
      {
        title: n,
        className: d ? T.titleMobile : T.title,
        children: /* @__PURE__ */ l.jsx(sr, { lineClamp: d ? 2 : 1, children: n })
      }
    ),
    !d && /* @__PURE__ */ l.jsx("ul", { className: T.badges, children: p == null ? void 0 : p.map((R) => /* @__PURE__ */ l.jsx("li", { children: /* @__PURE__ */ l.jsx(ur, { children: R }) }, R)) }),
    /* @__PURE__ */ l.jsx("div", { className: T.children, children: c }),
    /* @__PURE__ */ l.jsx("div", { className: T.actions, children: E == null ? void 0 : E() })
  ] })
] }) }), Yr = ({
  opened: n,
  onClose: p,
  title: c,
  children: E,
  size: C
}) => {
  const d = {
    font: "var(--leme-typography-body-semibold)"
  };
  return /* @__PURE__ */ l.jsxs(
    D.Root,
    {
      opened: n,
      onClose: p,
      size: C,
      radius: 16,
      children: [
        /* @__PURE__ */ l.jsx(D.Overlay, {}),
        /* @__PURE__ */ l.jsxs(
          D.Content,
          {
            style: { padding: "1.5rem", overflow: "hidden" },
            children: [
              /* @__PURE__ */ l.jsxs(D.Header, { style: { paddingTop: "0", paddingLeft: "0" }, children: [
                /* @__PURE__ */ l.jsx(D.Title, { style: d, children: c }),
                /* @__PURE__ */ l.jsx(D.CloseButton, {})
              ] }),
              /* @__PURE__ */ l.jsx(D.Body, { style: { padding: "0" }, children: E })
            ]
          }
        )
      ]
    }
  );
}, Mr = (n) => /* @__PURE__ */ l.jsx(
  fr,
  {
    styles: {
      root: {
        display: "grid",
        gap: "0.5rem"
      },
      input: {
        borderRadius: "var(--leme-rounded-md)",
        border: "1px solid var(--leme-color-gray-4)",
        color: "var(--leme-color-gray-7)",
        backgroundColor: "var(--leme-color-gray-0)",
        font: "var(--leme-typography-body-small-regular)",
        height: "2.5rem",
        padding: "8px 12px",
        "&:focus": {
          color: "var(--leme-color-gray-9)",
          border: "1px solid var(--leme-color-gray-9)"
        },
        "&:disabled": {
          borderColor: "var(--leme-color-gray-2)",
          backgroundColor: "var(--leme-color-gray-0) !important"
        }
      },
      label: {
        font: "var(--leme-typography-body-extra-small-regular)",
        color: "var(--leme-color-gray-7)",
        "&:focus-within": {
          color: "var(--leme-color-gray-9)"
        }
      }
    },
    ...n
  }
);
function Wr(n, p, c) {
  return {
    value: n,
    label: p,
    content: c
  };
}
const Br = ({ options: n, defaultValue: p }) => /* @__PURE__ */ l.jsxs(V, { defaultValue: p, styles: () => ({
  root: {
    display: "grid",
    gap: "2rem",
    p: {
      margin: 0
    }
  },
  tabsList: {
    borderBottom: 0,
    display: "flex",
    gap: "8px"
  },
  tab: {
    borderRadius: "var(--leme-rounded-md)",
    backgroundColor: "var(--leme-color-gray-0)",
    color: "var(--leme-color-gray-9)",
    font: "var(--leme-typography-body-small-regular)",
    height: 40,
    paddingInline: 16,
    "&[data-active], &:active": {
      backgroundColor: "var(--leme-color-gray-2)",
      border: 0
    },
    "&:hover": {
      backgroundColor: "var(--leme-color-gray-1)",
      color: "var(--leme-color-gray-7)",
      border: 0
    },
    "&:disabled, &[data-disabled]": {
      backgroundColor: "var(--leme-color-gray-0)",
      color: "var(--leme-color-gray-5)"
    }
  },
  panel: {
    font: "var(--leme-typography-body-small-regular)",
    color: "var(--leme-color-gray-9)",
    height: "calc(60vh - 40px - 32px)",
    overflowY: "auto"
  }
}), children: [
  /* @__PURE__ */ l.jsx(V.List, { children: n.map((c) => /* @__PURE__ */ l.jsx(
    V.Tab,
    {
      value: c.value,
      "data-testid": c.value,
      children: c.label
    },
    `tab-${c.value}`
  )) }),
  n.map((c) => /* @__PURE__ */ l.jsx(
    V.Panel,
    {
      value: c.value,
      children: c.content
    },
    `tab-panel-${c.value}`
  ))
] }), Dr = {
  fontFamily: "var(--leme-typography-family)",
  colors: {
    gray: [
      "#FFFFFF",
      "#F8F9FA",
      "#E9ECEF",
      "#DEE2E6",
      "#CED4DA",
      "#ADB5BD",
      "#6C757D",
      "#495057",
      "#343A40",
      "#212529"
    ]
  },
  primaryShade: 9,
  components: {
    Button: {
      styles: {
        root: {
          borderRadius: "var(--leme-rounded-md)"
        },
        leftIcon: {
          marginRight: "0.5rem",
          height: "24px"
        }
      },
      variants: {
        outline: () => ({
          root: {
            backgroundColor: "var(--leme-color-gray-0)",
            "&:hover": {
              backgroundColor: "var(--leme-color-gray-2)"
            },
            "&:active": {
              backgroundColor: "var(--leme-color-gray-2)"
            },
            "&:disabled, &[data-disabled]": {
              backgroundColor: "var(--leme-color-gray-0)",
              color: "var(--leme-color-gray-5)",
              borderColor: "var(--leme-color-gray-5)"
            }
          }
        })
      },
      sizes: {
        lg: () => ({
          root: {
            padding: "15px",
            font: "var(--leme-typography-body-large-medium)",
            height: "54px"
          }
        }),
        sm: () => ({
          root: {
            padding: "8px 15px",
            font: "var(--leme-typography-body-small-medium)",
            height: "40px"
          }
        })
      }
    },
    Badge: {
      styles: {
        root: {
          borderRadius: "var(--leme-rounded)",
          padding: "0.25rem 0.5rem",
          height: "24px",
          backgroundColor: "var(--leme-color-gray-2)"
        },
        inner: {
          font: "var(--leme-typography-body-extra-small-medium)",
          textTransform: "capitalize",
          color: "var(--leme-color-gray-7)"
        }
      }
    }
  }
}, qr = ({ children: n }) => /* @__PURE__ */ l.jsx(dr, { theme: Dr, children: n }), Lr = {
  xs: "30em",
  sm: "48em",
  md: "64em",
  lg: "80em",
  xl: "90em"
};
export {
  Lr as BREAKPOINTS,
  Ir as BlankSlate,
  Nr as Button,
  pr as Icon,
  Fr as Media,
  Yr as Modal,
  qr as Provider,
  Br as Tabs,
  Mr as TextInput,
  Wr as createTabOption
};
